/**
=========================================================
* Game My Biz — glass modal system
=========================================================
* Global look for every MUI Dialog: a light, futuristic frosted-glass paper
* over a soft blurred backdrop. Anchored to the Figma spec (radius, 14px blur,
* luminous border, 0 24 48 -8 shadow, inset top highlight). Kept white-ish and
* readable — never dark. Brand accents come from buttons/content, so nothing
* here hardcodes a brand color.
*/

const dialog = {
  styleOverrides: {
    root: {
      // Soft, light backdrop — dims just enough to focus, never dark.
      "& .MuiBackdrop-root": {
        backgroundColor: "rgba(15, 23, 42, 0.16)",
        backdropFilter: "blur(3px)",
        WebkitBackdropFilter: "blur(3px)",
      },
    },

    paper: {
      borderRadius: 8,
      border: "1px solid rgba(255, 255, 255, 0.6)",
      // Frosted white — see-through enough that the backdrop blur actually
      // reads as glass, while a strong 18px blur keeps content legible.
      backgroundColor: "rgba(255, 255, 255, 0.62)",
      backgroundImage: "none",
      backdropFilter: "blur(18px) saturate(160%)",
      WebkitBackdropFilter: "blur(18px) saturate(160%)",
      boxShadow:
        "0px 24px 48px -8px rgba(16, 24, 40, 0.18), inset 0px 1px 0px 0px rgba(255, 255, 255, 0.7)",
    },

    paperFullScreen: {
      borderRadius: 0,
    },
  },
};

export default dialog;
